import { Injectable } from '@angular/core';
import { Model } from 'survey-core';
import { LoggingUtilsService } from '../../../../../core/utils/logging.utils.service';
import {
  PeopleApiService,
  SnackbarService,
  MemberApiService,
  FormsBillingApiService,
  OfficesApiService,
  ApplicationsApiService,
  MemberPeopleApiService,
  CheckForPendingBlockingJobQueueItems
} from '@tangilla/tg-ng-core';
import { Office, Person, PersonRelationship, RequestParameters } from '@tangilla/tg-ng-models';
import { SurveyService } from 'src/app/core/services/survey/survey.service';
import { SurveyUtilsService } from './survey.utils.service';
import { ErrorsService } from 'src/app/core/services/utils/errors.service';
import { LicenseValidationFormWidgetService } from 'src/app/portal/form-processor/widgets/license-validation/service/license-validation-form.widget.service'
import { DetailsListWidgetService } from 'src/app/portal/form-processor/widgets/details-list/services/details-list.widget.service';
import { OfficesUtilsService } from '../../../../../core/services/utils/offices.utils.service';
@Injectable({
  providedIn: 'root'
})
export class ComplexFormParent { // TODO: Probably this needs to have a main class that will be used for Change Office, DL Transfer and Branch Office
  formatter: Intl.NumberFormat | any;
  dr_workflow: boolean = false

  constructor(
    protected peopleApiService: PeopleApiService,
    protected surveyService: SurveyService,
    protected memberApiService: MemberApiService,
    protected formsApiService: FormsBillingApiService,
    protected officesApiService: OfficesApiService,
    protected loggingUtilsService: LoggingUtilsService,
    protected snackbarService: SnackbarService,
    protected surveyUtils: SurveyUtilsService,
    protected applicationsService: ApplicationsApiService,
    protected peopleMemberApiService: MemberPeopleApiService,
    protected errorsService: ErrorsService,
    protected checkForPendingBlockingJobQueueItemsService: CheckForPendingBlockingJobQueueItems,
    protected licenseValidationFormWidgetService: LicenseValidationFormWidgetService,
    protected detailsListWidgetService: DetailsListWidgetService,
    protected officesUtilsService: OfficesUtilsService
  ) {
  }

  initializeForm(): any {
    this.formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });
    this.surveyService.surveyModel.setVariable('can_create_office', false)
    const previousOfficeQuestion = this.surveyService.surveyModel.getQuestionByName("previous_office");
    if (previousOfficeQuestion) {
      previousOfficeQuestion.value = this.surveyService.officeId;
    }

    this.checkForPendingBlockingJobQueueItems();

    this.setFormOnComplete();

    // Here goes the navigation code for the membership application form
    this.initializeOnAfterRenderPage();
    this.initializeOnCurrentPageChanging();
    this.initializeOnValueChanged();

    this.processApplicantInformation();
    this.processOfficeInformation();

  }

  setFormOnComplete() {

  }

  initializeOnAfterRenderPage() {

  }

  initializeOnCurrentPageChanging(){

  }

  initializeOnValueChanged() {
    this.surveyService.surveyModel.onValueChanged.add( (sender, options) => {
      if(options.name === 'CorpLicName') {
        // If creating new office and is with a corporate license, set business_name q
        // TODO: this is duplicated in application-form.ts
        if(options.value && sender.getValue('Office-Search-Type') === 'NewOffice' && sender.getValue('isCorp') === 'Yes') {
          sender.setValue('business_name', options.value);
          sender.setVariable('office_name', options.value)
          const businessNameQuestion = sender.getQuestionByName('business_name');
          if (businessNameQuestion) {
            businessNameQuestion.readOnly = true;
          }
        }
      }
    });
  }

  processApplicantInformation() {
    const personId = this.surveyService.personId;
    this.surveyService.surveyModel.setValue('person_id', personId);
    if (personId !== null) {
      this.surveyService.isLoading = true;
      this.peopleApiService.getPerson(personId)
        .subscribe({
          next: (person: Person) => {
            this.surveyService.personRecord = person;
            if(person.is_member_role) {
              this.surveyService.surveyModel.setVariable('can_create_office', true)
            }
            // process mapped data
            this.processPersonData()
            // get relationships data
            this.peopleApiService.getPersonRelationships(new RequestParameters(null), true, personId)
              .subscribe({
                next: (relationships) => {
                  this.surveyService.personRelationships = relationships.items;
                  this.setLicNumberQuestion(this.surveyService.personRelationships);
                  // Get member information
                  if(this.surveyService.personRecord?.member_nrds_id) {
                    // Get member information
                    this.memberApiService.getMember(this.surveyService.personRecord?.member_nrds_id)
                      .subscribe({
                        next: (member) => {
                          this.surveyService.memberRecord = member;
                          this.surveyService.isLoading = false;
                        },
                        error: (error: any) => {
                          this.errorsService.processError(error);
                          this.surveyService.isLoading = false;
                        }
                      });
                  }
                },
                error: (error) => {
                  this.surveyService.isLoading = false;
                  this.errorsService.processError(error);
                }
              });
          },
          error: (error) => {
            this.surveyService.isLoading = false;
            this.errorsService.processError(error);
          }
        });
    } else {
      this.snackbarService.error('Person ID is null');
    }
  }
  setLicNumberQuestion(personRelationships: PersonRelationship[]) {
    const validRelationships = personRelationships.filter(personRelationship =>
      personRelationship.license_number !== null && personRelationship.license_number.trim() !== ""
    );
    const uniqueLicenses = new Set(validRelationships.map(rel => rel.license_number));
    if (uniqueLicenses.size === 1) {
      const uniqueLicense = uniqueLicenses.values().next().value;
      this.licenseValidationFormWidgetService.licenseSubjects['LicNumber']?.licenseSearchSubject.next(uniqueLicense)
    }
  }

  processOfficeInformation() {
    // Get office information
    if(this.surveyService.officeId) {
      this.surveyService.isLoading = true;
      this.officesApiService.getOffice(this.surveyService.officeId)
        .subscribe({
          next: (office) => {
            this.surveyService.surveyModel.setVariable("current_office_name", office.business_name);
            this.surveyService.surveyModel.setValue('tangilla_sub_class_from', office.tangilla_office_class);
            this.surveyService.officeRecord = office;
            this.surveyService.isLoading = false;
          },
          error: (error) => {
            this.surveyService.isLoading = false;
            this.errorsService.processError(error);
          }
        });
    }
  }

  private processPersonData() {
    if (this.surveyService.surveyModel.getQuestionByName('FirstName')) {
      this.surveyService.surveyModel.setValue('FirstName',  this.surveyService.personRecord?.first_name);
      this.surveyService.surveyModel.getQuestionByName('FirstName').readOnly = true;
    }
    if (this.surveyService.surveyModel.getQuestionByName('LastName')) {
      this.surveyService.surveyModel.setValue('LastName', this.surveyService.personRecord?.last_name);
      this.surveyService.surveyModel.getQuestionByName('LastName').readOnly = true;
    }
    if (this.surveyService.surveyModel.getQuestionByName('FullName')) {
      this.surveyService.surveyModel.setValue('FullName', this.surveyService.personRecord?.first_name + ' ' + this.surveyService.personRecord?.last_name);
      this.surveyService.surveyModel.getQuestionByName('FullName').readOnly = true;
    }
    if (this.surveyService.surveyModel.getQuestionByName('PreferredName')) {
      this.surveyService.surveyModel.setValue('PreferredName', this.surveyService.personRecord?.preferred_name);
      this.surveyService.surveyModel.getQuestionByName('PreferredName').readOnly = true;
    }
    if (this.surveyService.surveyModel.getQuestionByName('emailaddress')) {
      this.surveyService.surveyModel.setValue('emailaddress', this.surveyService.personRecord?.email);
    }
    if (this.surveyService.surveyModel.getQuestionByName('Phone')) {
      this.surveyService.surveyModel.setValue('Phone', this.surveyService.personRecord?.mobile);
    }
  }

  protected setNoChargesHtmlTable() {
    let confirmationTableHTML = "<h4>Charge Summary for {FirstName} {LastName}</h4><table class=\"application_table\"><thead><tr><th>Description</th><th>Amount</th></tr></thead>";
    confirmationTableHTML += "<tr><td>Change Brokerage</td><td>No Charge</td></tr>"
    confirmationTableHTML += "<tr><td class=\"total\" colspan=\"1\">Total</td><td class=\"total\">"+this.formatter.format(0)+"</td></tr>";
    confirmationTableHTML += "<tr class='footer'><td colspan=\"2\" class=\"notation\">^includes tax</td></tr></table>";
    this.surveyService.surveyModel.getQuestionByName("ConfirmationContent")['html'] = confirmationTableHTML;
    this.surveyService.surveyModel.setVariable('totalcharge', 0);
  }

  protected buildOrderConfirmation(type: string) {

    const requestBody: any = {
      invoice_template_ids: [],
      person_id: this.surveyService.personId,
      adhoc_type: type,
      is_creating_new_office: false,
      include_recurring_charges: true, // This appears to always be true in the old implementation. This fees are only used by Cincy.
      // Of type is branch_office, we send the survey service office id, otherwise the selected office
      office_nrds_id: type === 'new_branch' ? this.surveyService.officeId : this.surveyService.surveyModel.getValue('office'),
      role_code: this.surveyService.personRelationships.find(r => r.is_main_relationship)?.role_code || null,
    }

    const officeSearchValue = this.surveyService.surveyModel.getValue('Office-Search-Type');

    const invoiceTemplateIdforType = this.surveyService.surveyModel.getVariable('invoice_templates')[type];
    if(invoiceTemplateIdforType) {
      requestBody.invoice_template_ids.push(invoiceTemplateIdforType);
      const newOfficeFeesInvoiceTemplateId = officeSearchValue && this.surveyService.surveyModel.getVariable('invoice_templates')[officeSearchValue];
      if(newOfficeFeesInvoiceTemplateId) {
        requestBody.invoice_template_ids.push(newOfficeFeesInvoiceTemplateId);
      }
    } else {
      requestBody.is_creating_new_office = !!(officeSearchValue && !this.surveyService.surveyModel.getVariable('selected_office'));
      requestBody.include_recurring_charges = true;
    }


    this.surveyService.isLoading = true;
    this.formsApiService.getFormCharges(requestBody)
      .subscribe({
        next: (charges) => {
          const chargeSummary: any[] = []
          const total = charges.fees.reduce((acc: number, fee: any) => {

            chargeSummary.push({
              product_invoice_item_id: fee.id,
              description: fee.description,
              price: fee.price,
              tax: fee.tax,
              tag: fee.tag,
              recn_destination_id: fee.recn_destination_id
            })

            return acc + fee.price + fee.tax
          }, 0);

          this.surveyService.surveyModel.setVariable('totalcharge', total);
          this.surveyService.surveyModel.setVariable('charges', charges);
          this.surveyService.surveyModel.setVariable('chargeSummary', JSON.stringify(chargeSummary));
          this.surveyService.surveyModel.setVariable('member_invoice', 'N');
          this.surveyService.surveyModel.setVariable('billing_year', charges.billing_year);
          this.surveyService.surveyModel.setVariable('totalchargef', this.formatter.format(total));

          const processedData = this.surveyUtils.getConfirmationChargesTable(
            charges,
            total,
            this.formatter,
            this.surveyService.surveyModel.getValue('FirstName'),
            this.surveyService.surveyModel.getValue('LastName'),
            this.surveyService.surveyModel.getVariable('form_title')
          );

          this.surveyService.surveyModel.setVariable('ConfirmationContentDetailsList', processedData);
          this.detailsListWidgetService.detailslistSubjects['ConfirmationContentDetailsList']?.detailslistSearchSubject.next('ConfirmationContentDetailsList')
          this.surveyService.isLoading = false;
        },
        error: (error) => {
          this.surveyService.isLoading = false;
          this.errorsService.processError(error)
        }
      });
  }

  protected validateMlsOfChoice(selectedOffice: Office) {

    // Compare current office MLS of choice with the new office MLS of choice
    const currentOffice:any = this.surveyService.officeRecord;
    const mlsOfChoice = this.surveyService.surveyModel.getVariable('custom_field_mls_of_choice');
    if (mlsOfChoice && currentOffice && currentOffice.custom_fields && currentOffice.custom_fields[mlsOfChoice]) {
      const currentOfficeMlsOfChoice = currentOffice.custom_fields[mlsOfChoice];
      const newOfficeMlsOfChoice = (selectedOffice as any).custom_fields[mlsOfChoice];
      if (currentOfficeMlsOfChoice !== newOfficeMlsOfChoice) {
        this.errorsService.exitForm('Error', `The office ${selectedOffice.business_name} (#${selectedOffice.office_nrds_id}) has a different MLS of choice than your current office. <br /><br /> Please contact the ${this.surveyService.surveyModel.getVariable('v-association')} to switch to this office.`);
        return;
      }
    }
  }

  private checkForPendingBlockingJobQueueItems() {
    const personId = this.surveyService.personId;
    // call checkForPendingBlockingJobQueueItems.get with query param person_id
    const request = new RequestParameters(null);
    request.setAdditionalFields({ person_id: personId });
    this.checkForPendingBlockingJobQueueItemsService.get(request)
    .subscribe({
      next: (response: any) => {
        if (response.has_pending_blocking_jobs) {
          this.errorsService.exitForm('The form is not currently available for you.', 'You have a pending task in progress, this can be related to a pending office change that is in progress or a DR upgrade in progress. Please try again later or contact support.');
        }
      },
      error: (error: any) => {
        this.errorsService.processError(error, 'soft');
      }
    });
  }


}
